import { AdminWorkspaceSubTypeV2Schema } from '@data-access/submissions/types';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';

const _submissionTypesEntityConfig = () =>
  entityConfig({
    collection: '_submissiontypes',
    entity: type<AdminWorkspaceSubTypeV2Schema>(),
    selectId: (entity) => entity.id,
  });

export const withSubmissionTypeEntities = () => {
  return signalStoreFeature(
    withEntities(_submissionTypesEntityConfig()),
    withMethods(({ ...store }) => ({
      loadSubmissionTypes: (data: AdminWorkspaceSubTypeV2Schema[]) => {
        return patchState(
          store,
          setAllEntities(data, _submissionTypesEntityConfig()),
        );
      },
    })),
  );
};
